<div class="toolkit">
	<div class="container">
		<div class="page-header">
			<div>
				<h1>{{ 'Toolkit.Menu.My_Toolkit' | translate }}</h1>
				<p class="subtitle">{{ 'Toolkit.Assigned.Banner.Subtitle' | translate }}</p>
			</div>
		</div>

		<div class="toolkit__tabsBar" *ngIf="!vm.loading && !vm.error && vm.hasRows">
			<div class="c-tabs u-no-mb my-toolkit-tabs">
				<button
					type="button"
					class="c-tabs__link c-tabs__link--sm"
					[ngClass]="{'c-tabs__link--active': vm.activeTab === 'pending'}"
					(click)="vm.selectTab('pending')">
					{{ 'Surveys.Pending' | translate }}
				</button>
				<button
					type="button"
					class="c-tabs__link c-tabs__link--sm"
					[ngClass]="{'c-tabs__link--active': vm.activeTab === 'history'}"
					(click)="vm.selectTab('history')">
					{{ 'Toolkit.Tabs.History' | translate }}
				</button>
			</div>
		</div>

		<div class="filters-bar my-toolkit-filters" *ngIf="!vm.loading && !vm.error && vm.hasRows">
			<select class="filter-select" [(ngModel)]="vm.kind" (ngModelChange)="vm.applyFilters()">
				<option value="ALL">{{ 'Toolkit.History.Filters.Type.All' | translate }}</option>
				<option value="EXERCISE">{{ 'Toolkit.History.Filters.Type.ExerciseOnly' | translate }}</option>
				<option value="SURVEY">{{ 'Toolkit.History.Filters.Type.SurveysOnly' | translate }}</option>
			</select>

			<input
				type="text"
				class="filter-search"
				placeholder="{{ 'Toolkit.Provider.Filters.Search.Placeholder' | translate }}"
				spellcheck="false"
				[(ngModel)]="vm.search"
				(ngModelChange)="vm.applyFilters()">
		</div>

		<loader-overlay *ngIf="vm.loading"></loader-overlay>

		<section class="section" *ngIf="!vm.loading && !vm.error && (vm.filteredExercises || []).length">
			<div class="exercise-list">
				<div
					class="exercise-card"
					*ngFor="let row of (vm.filteredExercises || [])"
					[ngClass]="{'completed': row.status === 'completed'}"
					(click)="vm.openItem(row)">
					<div
						class="exercise-status-icon"
						[ngClass]="{
							'completed': row.status === 'completed',
							'in-progress': row.status === 'overdue',
							'pending': row.status !== 'completed' && row.status !== 'overdue'
						}">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>
					</div>

					<div class="exercise-info">
						<h3>{{ row.title }}</h3>
						<div class="toolkit__completionBadge badge badge-green" *ngIf="row.status === 'completed'">
							{{ 'Toolkit.Common.Completed' | translate }}
						</div>
						<p class="text-sm text-muted">
							{{ vm.resourceFormatKey(row.format) | translate }}
							<span *ngIf="row.themeId"> · {{ vm.themeKey(row.themeId) | translate }}</span>
							<span *ngIf="row.durationMinutes != null"> · {{ row.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
						</p>
						<div class="therapist-note" *ngIf="row.note">
							<strong>{{ 'Toolkit.Preview.FromTherapist' | translate }}</strong><br>
							{{ row.note }}
						</div>
					</div>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#A0A5AB" stroke-width="2"><path d="M9 18l6-6-6-6"></path></svg>
				</div>
			</div>
		</section>

		<section class="section" *ngIf="!vm.loading && !vm.error && (vm.filteredSurveys || []).length">
			<div class="exercise-list">
				<div
					class="exercise-card"
					*ngFor="let row of (vm.filteredSurveys || [])"
					[ngClass]="{'completed': row.status === 'completed'}"
					(click)="vm.openItem(row)">
					<div
						class="exercise-status-icon"
						[ngClass]="{
							'completed': row.status === 'completed',
							'in-progress': row.status === 'overdue',
							'pending': row.status !== 'completed' && row.status !== 'overdue'
						}">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/><path d="M7 7h10M7 11h10M7 15h7"/></svg>
					</div>

					<div class="exercise-info">
						<h3>{{ row.title }}</h3>
						<div class="toolkit__completionBadge badge badge-green" *ngIf="row.status === 'completed'">
							{{ 'Toolkit.Common.Completed' | translate }}
						</div>
						<p class="text-sm text-muted">
							{{ 'Toolkit.History.Type.Survey' | translate }}
							<span *ngIf="row.code"> · {{ row.code }}</span>
							<span *ngIf="row.itemCount != null"> · {{ row.itemCount }} {{ 'Toolkit.Assessment.Common.Questions' | translate }}</span>
							<span *ngIf="row.durationMinutes != null"> · {{ row.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
						</p>
						<div class="therapist-note" *ngIf="row.note">
							<strong>{{ 'Toolkit.Preview.FromTherapist' | translate }}</strong><br>
							{{ row.note }}
						</div>
					</div>

                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#A0A5AB" stroke-width="2"><path d="M9 18l6-6-6-6"></path></svg>
                </div>
			</div>
		</section>

		<div class="empty-cell" *ngIf="!vm.loading && !vm.error && !(vm.filteredExercises || []).length && !(vm.filteredSurveys || []).length">
			{{ 'Toolkit.Clients.Empty' | translate }}
		</div>
	</div>
</div>
